export const visitorDomain = 'audioguide.ie';
export const visitorDomainSuffix = `.${visitorDomain}`;

export const reservedVisitorSubdomains = new Set([
  'www',
  'admin',
  'api',
  'mail',
  'smtp',
  'ftp',
  'autodiscover',
]);

export function normalizeVisitorSubdomain(value) {
  let input = String(value ?? '').trim().toLowerCase();
  input = input.replace(/^https?:\/\//, '').replace(/^\/+/, '').split(/[/?#]/)[0].replace(/:\d+$/, '').replace(/\.$/, '');
  if (input.endsWith(visitorDomainSuffix)) input = input.slice(0, -visitorDomainSuffix.length);
  return input;
}

export function suggestVisitorSubdomain(value) {
  return String(value ?? '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63)
    .replace(/-+$/g, '');
}

export function isValidVisitorSubdomain(value) {
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(normalizeVisitorSubdomain(value));
}

export function isReservedVisitorSubdomain(value) {
  return reservedVisitorSubdomains.has(normalizeVisitorSubdomain(value));
}

export function buildVisitorHostname(value) {
  const subdomain = normalizeVisitorSubdomain(value);
  return subdomain ? `${subdomain}${visitorDomainSuffix}` : '';
}
